import Reveal from "@/components/base/Reveal";
import { features } from "@/mocks/home";

const roleStyles: Record<string, string> = {
  primary: "bg-primary-100 text-primary-700 ring-primary-200",
  accent: "bg-accent-100 text-accent-700 ring-accent-200",
  secondary: "bg-secondary-100 text-secondary-800 ring-secondary-200",
};

export default function Features() {
  return (
    <section className="relative bg-background-50 py-20 md:py-28">
      <div className="mx-auto max-w-content px-5 md:px-8">
        <Reveal className="max-w-2xl">
          <span className="font-label text-xs tracking-[0.25em] text-primary-600">
            WHY MYEONGBULHEOJEON
          </span>
          <h2 className="mt-3 font-heading text-3xl font-black tracking-tight text-foreground-950 md:text-5xl">
            성적이 오르는 데는
            <br />
            이유가 있습니다
          </h2>
          <p className="mt-4 text-base leading-relaxed text-foreground-700">
            화려한 광고 대신, 학생의 실력이 실제로 바뀌는 시스템을 만들었습니다.
            수업·관리·점검이 하나의 흐름으로 이어집니다.
          </p>
        </Reveal>

        <div className="mt-12 grid gap-4 md:mt-14 md:grid-cols-2 lg:grid-cols-3">
          {features.map((feature, idx) => (
            <Reveal key={feature.title} delay={idx * 70}>
              <article className="group h-full rounded-2xl border border-background-200 bg-background-100/70 p-6 transition-colors duration-300 hover:border-primary-300 hover:bg-background-100 md:p-7">
                <span
                  className={`flex h-12 w-12 items-center justify-center rounded-xl ring-1 ${
                    roleStyles[feature.role] ?? roleStyles.primary
                  }`}
                >
                  <i className={`${feature.icon} text-2xl`} />
                </span>
                <h3 className="mt-5 font-heading text-lg font-bold tracking-tight text-foreground-950">
                  {feature.title}
                </h3>
                <p className="mt-2 text-sm leading-relaxed text-foreground-700">
                  {feature.desc}
                </p>
                <span className="mt-5 block h-px w-8 bg-primary-500 transition-all duration-300 group-hover:w-16" />
              </article>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}